import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=355f77cc&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=355f77cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f77cc",
  null
  
)

export default component.exports